import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import HeaderLinks from "../Header/HeaderLinks.jsx";

import imagine from "assets/img/sidebar-4.jpg";
import logo from "assets/img/logo-TAD-d.png";

import Estudiante from "routes/Estudiante";
import Profesor from "routes/Profesor";
import Directivo from "routes/Directivo";
import Administrativo from "routes/Administrativo";
import WebMaster from "routes/WebMaster";
import Consulta from "routes/Consulta";

class Sidebar extends Component {
  state = {
    width: window.innerWidth,
    user: "",
    menus:[]
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "menu-activo" : "menu-imactivo";
  }

  activeRouteColor(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "menu-activo-color" : "menu-imactivo-color";
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    },() => {
      this.menus();
    });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  menus = () => {
    let tipo = this.props.type;
    switch (tipo) {
      case "EST":
        this.setState({ menus : Estudiante, user: "Estudiante"});
        break;
      case "PROF":
        this.setState({ menus : Profesor, user: "Profesor"});
        break;
      case "DIR":
        this.setState({ menus : Directivo, user: "Directivo" });
        break;
      case "ADMIN":
        this.setState({ menus : Administrativo, user: "Administrativo" });
        break;
      case "WEBMASTER":
        this.setState({ menus : WebMaster, user: "Web Master" });
        break;
      case "CONSULTA":
        this.setState({ menus : Consulta, user: "Consulta" });
        break;
      default:
          return(<div></div>)
    }
  }

  render() {

    const sidebarBackground = {
      backgroundImage: "url(" + imagine + ")",
    };

    return (
      <div
        id="sidebar"
        className="sidebar"
        data-color="custom" /* para cambiar el scss buscar $new-custom */
        data-image={imagine}
        style = {{zIndex: 4, boxShadow: "1px 1px 3px #000"}}
      >
        <div className="sidebar-background" style={sidebarBackground} />
        <div className="logo" align="center" style={{borderBottom: "1px solid", borderBottomColor:"#e6e6e6", height:63}}>
          <div>
            <img src={logo} alt="Logo" width="auto" height="50px"/>
          </div>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {this.state.width <= 991 ? <HeaderLinks userName = {this.props.userName} tUser = {this.state.user}/> : null}
            {/* <li className="sidebar-user" align="center">Has ingresado como <strong>{this.state.user}</strong></li> */}
            {this.state.menus.map((prop, key) => {
              if (!prop.redirect)
                return (
                  <li
                    className={
                      this.activeRoute(prop.path)
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.path}
                      
                      /* activeClassName="active" */
                      onClick={this.props.extend}
                      className={this.activeRouteColor(prop.path)}
                    >
                      <i className={prop.icon}/>
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              return null;
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx